import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  message = 'Loading...'
}) => {
  const sizeClasses = {
    sm: 'h-5 w-5 border-[1.5px]',
    md: 'h-8 w-8 border-2',
    lg: 'h-10 w-10 border-2'
  };

  return (
    <div className="flex flex-col items-center justify-center p-8">
      <div
        className={`animate-spin rounded-full border-neutral-200 border-t-neutral-900 ${sizeClasses[size]} mb-4`}
        role="status"
        aria-label="Loading"
      />
      {message && (
        <p className="text-neutral-500 text-caption">{message}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;
